import api from "@/requests";

export const checkHasConsent = () =>
  api.get("api/v1/Myred/CheckHasConsent");

export function saveConsent(isConsentRequired) {
  return api.get(`api/v1/Myred/SaveConsent/${isConsentRequired}`);
}